module.exports = __webpack_public_path__ + "static/img/logo.8334b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 184